import { setUser, userSelector } from '@/core/store/user/userSlice';
import { useAppSelector } from '@/hooks';
import Switch from '../Switch/Switch';
import { useTranslation } from 'react-i18next';
import { getUser, patchUser } from '@/core/api';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import { useModal } from '../Modal/useModal';

export const DatevEmailSubscription = () => {
  const user = useAppSelector(userSelector);
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const {
    isModalOpened: isModalOpened,
    closeModal: closeModal,
    openModal: openModal,
  } = useModal();

  const updateDatevEmailSubscription = (
    DatevEmailSubscription: boolean,
    onSuccess?: () => void,
    onFail?: () => void
  ) => {
    setIsLoading(true);
    patchUser({
      DatevEmailSubscription,
    })
      .then(() => {
        return getUser();
      })
      .then(() => {
        if (!user) return;

        setIsLoading(false);
        dispatch(
          setUser({
            ...user,
            DatevEmailSubscription,
          })
        );
        setIsLoading(false);
        onSuccess?.();
      })
      .catch(() => {
        onFail?.();
      });
  };

  return (
    <div className='mb-4 ml-auto flex items-center justify-between gap-x-4 rounded-lg border-2 border-white bg-white bg-opacity-50 px-4 py-2'>
      <div className='font-semibold'>
        {t('Notify me, when DATEV exports can be generated')}
      </div>
      <Switch
        name='datevEmailSubscription'
        disabled={isLoading}
        className='shrink-0'
        checked={user?.DatevEmailSubscription || false}
        onChange={() => {
          if (!user) return;

          const datevEmailSubscription = !user.DatevEmailSubscription;
          if (!datevEmailSubscription) {
            return openModal();
          }

          updateDatevEmailSubscription(!user.DatevEmailSubscription);
        }}
      />
      <ConfirmModal
        isModalOpened={isModalOpened}
        closeModal={closeModal}
        confirm={(setIsConfirming) => {
          setIsConfirming(true);
          updateDatevEmailSubscription(
            false,
            () => {
              setIsConfirming(false);
              closeModal();
            },
            () => {
              setIsConfirming(false);
            }
          );
        }}
        confirmBtnText='Do not notify me'
        title='Confirmation needed'
        danger
      >
        <div className='mb-2 text-h4 font-extrabold'>
          {t('Please confirm the deactivation of notifications')}
        </div>
        <div className='mb-4'>
          {t(
            'You will not receive any email notifications related to DATEV exports.'
          )}
        </div>
      </ConfirmModal>
    </div>
  );
};
